"use strict";
var appn;
(function (appn) {
    var trash;
    (function (trash) {
        function deleteConfirm($parentForm, submitType, ignoreValidation, msgDetail, msgOverride) {
            const detail = appn.elementBuilder.createElement('p', undefined, undefined, undefined, T('The selected item(s) will be permanently deleted.'));
            if (msgDetail)
                detail.innerHTML = msgDetail;
            const message = appn.elementBuilder.createElement('p', undefined, undefined, undefined, T('This action can not be undone.'));
            if (msgOverride || msgOverride === appn.emptyString)
                message.innerHTML = msgOverride;
            const confirmation = appn.elementBuilder.createElement('p', 'trash-confirm-msg', undefined, undefined, T('Hit the <b>Delete</b> button to proceed.'));
            const buttonConfig = {
                confirm: {
                    label: '<span>' + T('Delete') + '</span><i class="fa fa-times-circle"></i>',
                    className: 'btn-danger',
                    callback: function (result) {
                        if (result) {
                            $parentForm.append('<input type="hidden" name="submitType" value="' + submitType + '" />');
                            if (ignoreValidation)
                                $parentForm.validate().cancelSubmit = true;
                            $parentForm.submit();
                        }
                    }
                }
            };
            appn.dialog.custom({
                modalColor: 'modal-danger',
                title: T('Confirm Delete'),
                message: detail.outerHTML + (message.outerHTML.length > 0 ? message.outerHTML : appn.emptyString) + confirmation.outerHTML,
                className: 'appnGlobalConfirmDelete',
                isDeleteAction: true,
                closeButton: true,
                buttons: buttonConfig
            });
        }
        trash.deleteConfirm = deleteConfirm;
        function trashConfirm($parentForm, submitType, msgDetail, msgOverride) {
            let detail = appn.elementBuilder.createElement('p', undefined, undefined, undefined, T('The selected item(s) will be moved to Trash and will no longer be available for use.'));
            if (msgDetail)
                detail.innerHTML = msgDetail;
            const message = appn.elementBuilder.createElement('p', undefined, undefined, undefined, T('You will have 30 days to restore from the Trash area before the item(s) are permanently deleted from the system.'));
            if (msgOverride)
                message.innerHTML = msgOverride;
            const confirmation = appn.elementBuilder.createElement('p', 'trash-confirm-msg', undefined, undefined, T('Hit the <b>Trash</b> button to proceed.'));
            const buttonConfig = {
                trash: {
                    label: '<span>' + T('Trash') + '</span><i class="fa fa-trash"></i>',
                    className: 'btn-danger',
                    callback: function (result) {
                        if (result) {
                            $parentForm.append('<input type="hidden" name="submitType" value="' + submitType + '" />');
                            $parentForm.validate().cancelSubmit = true;
                            $parentForm.submit();
                        }
                    }
                }
            };
            appn.dialog.custom({
                modalColor: 'modal-danger',
                title: T('Move To Trash?'),
                message: detail.outerHTML + message.outerHTML + confirmation.outerHTML,
                className: 'appnGlobalConfirmTrash',
                isTrashAction: true,
                closeButton: true,
                buttons: buttonConfig
            });
        }
        trash.trashConfirm = trashConfirm;
        function getTrashDetailsFromTable(name, version, status) {
            return {
                name: cleanCellText(name),
                version: version ? Number(version.text()) : undefined,
                status: status ? status.text() : undefined
            };
        }
        trash.getTrashDetailsFromTable = getTrashDetailsFromTable;
        function createTrashMessageFromTable(button, selectedRows, itemsType, nameCol = 1, versionCol, statusCol) {
            let msg;
            button.attr('data-trashdetail', appn.emptyString);
            const headers = $('table.dataTable[id] thead tr th');
            headers.each(function (index, value) {
                const headerText = $(value).find('div').text();
                switch (headerText.trim()) {
                    case 'Version':
                        versionCol = index;
                        break;
                    case 'Status':
                        statusCol = index;
                        break;
                }
            });
            if (selectedRows.length > 1) {
                const ul = appn.elementBuilder.createElement('ul', (selectedRows.length > 5 ? 'scroller' : undefined));
                selectedRows.each(function (index, selected) {
                    const trashItem = trash.getTrashDetailsFromTable($($(selected).closest('tr').find('td')[nameCol]), versionCol ? $($(selected).closest('tr').find('td')[versionCol]) : undefined, statusCol ? $($(selected).closest('tr').find('td')[statusCol]) : undefined);
                    let itemMsg = `<b>${trashItem.name}`;
                    if (trashItem.version) {
                        itemMsg += ` (${T('Version')} ${trashItem.version}`;
                        if (trashItem.status)
                            itemMsg += ` - ${trashItem.status}`;
                        itemMsg += `)`;
                    }
                    itemMsg += '</b>';
                    const li = appn.elementBuilder.createElement('li', undefined, undefined, undefined, itemMsg);
                    ul.appendChild(li);
                });
                msg = T('The following <b>{0}</b> and all associated data/versions will be moved to Trash.', itemsType) + ul.outerHTML;
            }
            else {
                const trashItem = trash.getTrashDetailsFromTable($($(selectedRows[0]).closest('tr').find('td')[nameCol]), versionCol ? $($(selectedRows[0]).closest('tr').find('td')[versionCol]) : undefined, statusCol ? $($(selectedRows[0]).closest('tr').find('td')[statusCol]) : undefined);
                let itemMsg = `<b>${trashItem.name} `;
                if (trashItem.version) {
                    itemMsg += `(${T('Version')} ${trashItem.version}`;
                    if (trashItem.status)
                        itemMsg += ` - ${trashItem.status}`;
                    itemMsg += `)`;
                }
                itemMsg += '</b>';
                msg = T('{0} and all associated data/versions will be moved to Trash.', itemMsg);
            }
            const p = appn.elementBuilder.createElement('p', undefined, undefined, undefined, msg);
            button.attr('data-trashdetail', JSON.stringify(p.outerHTML));
        }
        trash.createTrashMessageFromTable = createTrashMessageFromTable;
        function addTrashMessage(button, nameSelect, versionSelect, statusSelect, hasVersions = true) {
            const trashAll = button.val().containsIgnoreCase('TrashAll');
            const isTrash = button.val().containsIgnoreCase('Trash');
            const isdelete = button.val().containsIgnoreCase('Delete');
            if (isTrash)
                button.attr('data-trashdetail', appn.emptyString);
            if (isdelete)
                button.attr('data-deletedetail', appn.emptyString);
            const trashItem = {
                name: $(`${nameSelect}`).val(),
                version: Number($(`label[for="${versionSelect}"]`).closest('.form-group').find('.col-md-7 .col-form-label').text()),
                status: $(`label[for="${statusSelect}"]`).closest('.form-group').find('.col-md-7 .col-form-label').text()
            };
            let itemMsg = `<b>${trashItem.name}`;
            if (trashItem.version) {
                itemMsg += ` (${T('Version')} ${trashItem.version}`;
                if (trashItem.status)
                    itemMsg += ` - ${trashItem.status}`;
                itemMsg += `)`;
            }
            itemMsg += '</b>';
            let msg = `${isdelete ? T('{0} will be permanently deleted.', itemMsg) : T('{0} will be moved to Trash and will no longer be available for use.', itemMsg)}${hasVersions ? T('<p><b>Note:</b> Only the current version will be moved to Trash.<p>') : ''}`;
            if (trashAll)
                msg = T('{0} and all associated data {1}will be moved to Trash.', itemMsg, hasVersions ? T('(including ALL versions) ') : '');
            if (isTrash)
                button.attr('data-trashdetail', JSON.stringify(msg));
            else if (isdelete)
                button.attr('data-deletedetail', JSON.stringify(msg));
        }
        trash.addTrashMessage = addTrashMessage;
        function addConnectorDeleteMessage(button) {
            button.attr('data-deletedetail', appn.emptyString);
            button.attr('data-deletemessage', appn.emptyString);
            const desc = button.closest('.connector').find('.card-header input[id^="Connectors"]').val();
            const msg = T('<b>{0}</b> is about to be permanently disconnected and deleted.', desc);
            button.attr('data-deletedetail', JSON.stringify(msg));
            button.attr('data-deletemessage', ' ');
        }
        trash.addConnectorDeleteMessage = addConnectorDeleteMessage;
        function cleanCellText(cell) {
            return cell.clone()
                .find('.dt-titleText')
                .text()
                .trim();
        }
        trash.cleanCellText = cleanCellText;
    })(trash = appn.trash || (appn.trash = {}));
})(appn || (appn = {}));
